import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getOperatorLogList, queryClientList, getNodeLogList, getDateOperatorLogList, getMediaWallProgram, getMediaWallList} from '@apis'
import moment from 'moment'
import consumptionBg from '../../../assets/img/consumptionBg.png'

const TodayDynamics = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId, brokerId} = userInfo
    const [clientNum, setClientNum] = useState()
    const [programNum, setProgramNum] = useState(0)
    const [playNum, setPlayNum] = useState()
    const [statusAlarm, setStatusAlarm] = useState()

    // 获取节点监控信息
    async function queryNodeList(index) {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallProgram(params)
      if (res && res.data) {
        let num = 0
        res.data.map(item => {
          if(item.taskSwitch) {
            if(item.playFrequency == 1) {
              item.weekList.map(value => {
                if(value == new Date().getDay()) {
                  item.timeThresholdList.map(i => {
                    if(moment(Number(i.playTimeStart)).format("HH:mm:ss") <= moment(new Date().getTime()).format("HH:mm:ss")) {
                      num++
                    }
                  })
                }
              })
            } else {
              if(moment(Number(item.playDayStart)).format("YYYY:MM:DD") <= moment(new Date()).format("YYYY:MM:DD") && 
              moment(Number(item.playDayEnd)).format("YYYY:MM:DD") >= moment(new Date()).format("YYYY:MM:DD")) {
                item.timeThresholdList.map(i => {
                  if(moment(Number(i.playTimeStart)).format("HH:mm:ss") <= moment(new Date().getTime()).format("HH:mm:ss")) {
                    num++
                  }
                })
              }
            }
          }
        })
        setProgramNum(index+num)
      }
    }

    // 获取节点离线信息列表
    async function queryNodeLogList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getNodeLogList(params)
      if (res && res.data) {
        let num = 0
        res.data.map(item => {
          if(item.offlineTime && item.brokerId == brokerId) {
            if(moment(item.offlineTime).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) {
              num++
            }
          }
        })
        setStatusAlarm(num)
      }
    }
    
    function queryDateOperator() {
      const params = {
        brokerId,
        startTime: moment(new Date()).format('YYYY-MM-DD')
      }
      getDateOperatorLogList(params).then(res => {
        if(res) {
          let num = 0
          res.map(values => {
            if(values.operatorUrl == '/program/playProgram' && JSON.parse(values.json).playStatus == 1) {
              num++
            }
          })
          queryNodeList(num)
        }
      })
    }

    // 获取节点信息
    async function queryMediaWallList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        getClientList(res.data)
      }
    }

    // 获取节点监控信息
    async function getClientList(value) {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await queryClientList(params)
      if (res && res.data) {
        let nodeClientList = 0
        value.map(item => {
          res.data.data.map(e => {
            if(item.code == e.appCode) {
              nodeClientList++
            }
          })
        })
        setClientNum(nodeClientList)
      }
    }

    // 获取操作日志信息
    async function getOperatorLog() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getOperatorLogList(params)
      if (res && res.data) {
        const operator = res.data.filter(item => moment(item.gmtCreate).format('YYYY:MM:DD')===moment(new Date()).format('YYYY:MM:DD'))
        setPlayNum(operator.length)
      }
    }

    useEffect(() => {
      queryNodeLogList()
      queryMediaWallList()
      getOperatorLog()
      queryDateOperator()
    }, [])

    return (
      <div className='ck-today-dynamic'>
        <div className='title'>今日动态</div>
        <img className='ck-today-bg' src={consumptionBg}/>
        <div className='today-item'>
          <div className='today-index'>
            <div className='today-top'>
              <div className='today-left'>
                {/* <span className='today-name'>播放时间</span>
                <span className='today-num'>10:20:20</span> */}
                <span className='today-name'>节点监控数量</span>
                <span className='today-num'>{clientNum}个</span>
              </div>
              <div className='today-right'>
                <span className='today-name'>播放次数</span>
                <span className='today-num'>{programNum ? programNum : 0}次</span>
              </div>
            </div>
            <div className='today-center'>
              <div className='today-left'>
                <span className='today-name'>状态告警次数</span>
                <span className='today-num' style={{color: 'red'}}>{statusAlarm ? statusAlarm :0}个</span>
              </div>
              <div className='today-right'>
                <span className='today-name'>操作处理次数</span>
                <span className='today-num'>{playNum}个</span>
              </div>
            </div>
            {/* <div className='today-bottom'>
              <div className='today-left'>
                <span className='today-name'>节目播放状态</span>
                <span className='today-num'>良好</span>
              </div>
              <div className='today-right'>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    )
  })
)

export default TodayDynamics